var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"disabled":_vm.disabled,"value":_vm.chosenItem},on:{"change":_vm.onChange}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }